import { useRef, useEffect } from 'react';
import { Form } from 'antd';
import { isProfessionRequiredByEvaluationType } from '../../../utils/evaluationRules';
import countrySettings from '../countrySettings.json';

const useProfessionField = (form, countryCode, evaluationTypesData) => {
  const previousProfession = useRef();
  const selectedEvaluationType = Form.useWatch('evaluation_type', form);

  const countryRequiresProfession = !!countrySettings.patientForm.professionRequired?.[countryCode];
  const isProfessionRequired = countryRequiresProfession && isProfessionRequiredByEvaluationType(selectedEvaluationType, countryCode, evaluationTypesData);
  const isProfessionEditable = !countryRequiresProfession || isProfessionRequired;

  useEffect(() => {
    if (!countryRequiresProfession) return;

    if (!isProfessionRequired) {
      previousProfession.current = form.getFieldValue('profession');
      form.setFieldsValue({ profession: undefined });
    } else if (previousProfession.current) {
      form.setFieldsValue({ profession: previousProfession.current });
      previousProfession.current = undefined;
    }
  }, [selectedEvaluationType, countryCode, form, isProfessionRequired, countryRequiresProfession]);

  return {
    isProfessionRequired,
    isProfessionEditable,
  };
};

export default useProfessionField;
